import { render } from "./NewRaceDialog.vue?vue&type=template&id=3327d1a8&scoped=true"
import script from "./NewRaceDialog.vue?vue&type=script&lang=js"
export * from "./NewRaceDialog.vue?vue&type=script&lang=js"

import "./NewRaceDialog.vue?vue&type=style&index=0&id=3327d1a8&scoped=true&lang=css"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3327d1a8"]])

export default __exports__